<template>
<div class="driver-bd-content">


      <!-- SUB TABS -->
      <ul class="nav nav-pills mb-3 driver-subtabs">
        <li class="nav-item flex-fill text-center">
          <a
            href="#"
            class="nav-link"
            :class="{ active: activeTab === 'LIST' }"
            @click.prevent="activeTab = 'LIST'"
          >
            <i class="fa fa-list-alt mr-1 d-none d-sm-inline"></i>
            <span>Danh sách</span>
          </a>
        </li>
        <!-- <li class="nav-item flex-fill text-center">
          <a
            href="#"
            class="nav-link"
            :class="{ active: activeTab === 'CREATE' }"
            @click.prevent="activeTab = 'CREATE'"
          >
            <i class="fa fa-plus-circle mr-1 d-none d-sm-inline"></i>
            <span>Tạo phiếu</span>
          </a>
        </li> -->
        <li class="nav-item flex-fill text-center">
          <a
            href="#"
            class="nav-link"
            :class="{ active: activeTab === 'DETAIL', disabled: !currentTicket }"
            @click.prevent="goToDetailTab"
          >
            <i class="fa fa-file-alt mr-1 d-none d-sm-inline"></i>
            <span>Chi tiết</span>
          </a>
        </li>
      </ul>

      <!-- TAB: LIST -->
      <section v-if="activeTab === 'LIST'">
        <!-- Filter trạng thái -->
        <div class="card card-tabs mb-2">
          <div class="card-header p-0 border-bottom-0">
            <div class="nav-tabs-scrollable">
              <ul class="nav nav-tabs nav-tabs-bottom">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                    :class="{ active: filterTrangThai === 'ACTIVE' }"
                    @click.prevent="filterTrangThai = 'ACTIVE'"
                  >
                    Đang xử lý
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="#"
                    :class="{ active: filterTrangThai === 'DONE' }"
                    @click.prevent="filterTrangThai = 'DONE'"
                  >
                    Hoàn thành / Đã đóng
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- List tickets -->
        <div v-if="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 mb-0 text-muted">Đang tải danh sách phiếu...</p>
        </div>

        <div
          v-else-if="error"
          class="alert alert-danger d-flex align-items-center"
        >
          <i class="fa fa-exclamation-triangle mr-2"></i>
          <span class="flex-grow-1">{{ error }}</span>
          <button class="btn btn-sm btn-danger ml-2" @click="handleReload">
            Thử lại
          </button>
        </div>

        <div
          v-else-if="!filteredTickets.length"
          class="text-center py-5 text-muted"
        >
          <i class="fa fa-check-circle fa-2x mb-2 text-success"></i>
          <p v-if="filterTrangThai === 'DONE'">
            Không có phiếu đã hoàn thành / đã đóng.
          </p>
          <p v-else>Hiện không có phiếu nào đang xử lý.</p>
        </div>

        <div v-else class="driver-ticket-list">
          <div
            v-for="t in filteredTickets"
            :key="t.id"
            class="card ticket-card mb-2"
            @click="openTicket(t)"
          >
            <div class="card-body py-2 px-3">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1 pr-2">
                  <div class="d-flex align-items-center mb-1">
                    <span class="xe-tag mr-2">
                      <i class="fa fa-car mr-1"></i>{{ t.xeBienSo || "N/A" }}
                    </span>
                    <span
                      class="badge mr-1"
                      :class="getStatusBadge(t.trangThai)"
                    >
                      {{ formatTrangThai(t.trangThai) }}
                    </span>
                    <span
                      class="badge badge-source"
                      :class="getLoaiBadge(t.loaiBaoDuong)"
                    >
                      {{ formatLoai(t.loaiBaoDuong) }}
                    </span>
                  </div>

                  <div class="ticket-title-row">
                    <strong class="ticket-title">
                      {{ truncate(t.tenHangMuc || t.noiDungCongViec, 60) }}
                    </strong>
                  </div>

                  <div
                    class="small text-muted mt-1 d-flex flex-wrap align-items-center"
                  >
                    <span class="mr-2">
                      <i class="fa fa-clock-o mr-1"></i>
                      {{ formatDateTime(t.ngayTao) }}
                    </span>

                    <span
                      v-if="t.huongXuLy"
                      class="badge badge-pill badge-outline-dark ml-1 mt-1 mt-sm-0"
                    >
                      {{ formatHuongXuLy(t.huongXuLy) }}
                    </span>
                  </div>
                </div>

                <div class="text-right ml-1 min-action-width">
                  <div
                    v-if="t.chiPhiThucTe"
                    class="text-danger font-weight-bold small mb-1"
                  >
                    {{ formatCurrency(t.chiPhiThucTe) }}
                  </div>
                  <div
                    v-else-if="t.giaDuocDuyet"
                    class="text-success small font-weight-bold mb-1"
                  >
                    Duyệt: {{ formatCurrency(t.giaDuocDuyet) }}
                  </div>
                  <button type="button" class="btn btn-outline-primary btn-xs">
                    Xem
                    <i class="fa fa-chevron-right ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TAB: CREATE -->
      <section v-else-if="activeTab === 'CREATE'">
        <div class="card">
          <div class="card-header py-2 d-flex align-items-center">
            <h5 class="mb-0" style="font-size: 15px">
              <i class="fa fa-plus-circle mr-2"></i>Tạo Phiếu Bảo dưỡng / Sửa chữa
            </h5>
          </div>
          <div class="card-body pb-2">
            <div v-if="createError" class="alert alert-danger py-2 mb-2">
              {{ createError }}
            </div>

            <form @submit.prevent="handleCreateTicket">
              <div class="form-group mb-2">
                <label class="mb-1">
                  Xe <span class="text-danger">*</span>
                </label>
                <select
                  v-model="createForm.xeBienSo"
                  class="form-control form-control-sm"
                  required
                >
                  <option value="" disabled>-- Chọn / nhập biển số xe --</option>
                  <option
                    v-for="(opt, idx) in distinctXeBienSo"
                    :key="idx"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </select>
                <small class="text-muted">
                  Tạm dùng từ lịch sử phiếu. Sau có API xe thì thay dropdown chuẩn.
                </small>
              </div>

              <div class="form-group mb-2">
                <label class="mb-1">Bộ phận hỏng / Vị trí trên xe</label>
                <input
                  v-model.trim="createForm.boPhan"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="VD: Vỏ sau bên phải, đèn pha, thắng trước..."
                />
              </div>

              <div class="form-group mb-2">
                <label class="mb-1">
                  Mô tả sự cố <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model.trim="createForm.noiDungCongViec"
                  class="form-control form-control-sm"
                  rows="3"
                  required
                  maxlength="2000"
                  placeholder="Mô tả rõ tình trạng, tiếng kêu, đèn báo lỗi, lúc nào xảy ra..."
                ></textarea>
              </div>

              <div class="form-group mb-2">
                <label class="mb-1">
                  Ảnh vị trí hỏng / sản phẩm thay
                </label>
                <div v-if="createForm.anhSuCoUrl" class="mb-1">
                  <div class="input-group input-group-sm">
                    <input
                      type="text"
                      class="form-control"
                      :value="createForm.anhSuCoUrl"
                      readonly
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-outline-danger"
                        @click="createForm.anhSuCoUrl = ''"
                      >
                        Xóa
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else>
                 
                </div>
              </div>

              <div class="form-group mb-3">
                <label class="mb-1">ODO hiện tại (Km)</label>
                <input
                  v-model.number="createForm.odoLucTao"
                  type="number"
                  min="0"
                  class="form-control form-control-sm"
                  placeholder="Nếu nhớ thì nhập, không thì bỏ qua"
                />
              </div>

              <button
                type="submit"
                class="btn btn-primary btn-block btn-sm py-2"
                :disabled="isSubmittingCreate"
              >
                <span
                  v-if="isSubmittingCreate"
                  class="spinner-border spinner-border-sm"
                ></span>
                <i v-else class="fa fa-save mr-1"></i>
                Gửi Phiếu
              </button>
            </form>
          </div>
        </div>
      </section>

      <!-- TAB: DETAIL + CHAT -->
      <section v-else-if="activeTab === 'DETAIL'">
        <div v-if="isLoadingDetail" class="text-center py-5">
          <div
            class="spinner-border text-primary"
            style="width: 2.5rem; height: 2.5rem"
          ></div>
          <p class="mt-3 text-muted">Đang tải chi tiết phiếu...</p>
        </div>

        <div v-else-if="detailError" class="alert alert-danger py-2">
          {{ detailError }}
        </div>

        <div v-else-if="!currentTicket" class="text-center text-muted py-5">
          Chưa chọn phiếu nào. Vui lòng chọn từ tab <b>Danh sách</b>.
        </div>

        <div v-else class="row">
          <!-- LEFT: INFO + ACTION -->
          <div class="col-lg-5 mb-3">
            <!-- INFO -->
            <div class="card mb-2">
              <div
                class="card-header py-2 d-flex justify-content-between align-items-center"
              >
                <div>
                  <h5 class="mb-0" style="font-size: 15px">
                    Phiếu #{{ currentTicket.id }}
                  </h5>
                  <small class="text-muted">
                    {{ formatDateTime(currentTicket.ngayTao) }}
                  </small>
                </div>
                <span
                  class="badge"
                  :class="getStatusBadge(currentTicket.trangThai)"
                >
                  {{ formatTrangThai(currentTicket.trangThai) }}
                </span>
              </div>
              <div class="card-body p-2">
                <table class="table table-sm mb-1 ticket-info-table">
                  <tbody>
                    <tr>
                      <td>Xe</td>
                      <td>
                        <strong>{{ currentTicket.xeBienSo || "N/A" }}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>Loại</td>
                      <td>
                        <span
                          class="badge badge-source"
                          :class="getLoaiBadge(currentTicket.loaiBaoDuong)"
                        >
                          {{ formatLoai(currentTicket.loaiBaoDuong) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Bộ phận</td>
                      <td>{{ currentTicket.boPhan || "-" }}</td>
                    </tr>
                    <tr>
                      <td>Nội dung</td>
                      <td>{{ currentTicket.noiDungCongViec }}</td>
                    </tr>

                    <tr>
                      <td class="align-top pt-2">Ảnh sự cố</td>
                      <td>
                        <div
                          v-if="ticketImages.suCo.length > 0"
                          class="img-grid-wrapper"
                        >
                          <div
                            v-for="(img, idx) in ticketImages.suCo"
                            :key="'sc-' + idx"
                            class="img-thumb-item"
                            @click="showLightbox(ticketImages.suCo, idx)"
                          >
                            <img :src="img" />
                          </div>
                        </div>
                        <span v-else class="text-muted small">-</span>
                      </td>
                    </tr>

                    <tr>
                      <td>ODO lúc tạo</td>
                      <td>
                        {{
                          currentTicket.odoLucTao
                            ? currentTicket.odoLucTao + " km"
                            : "-"
                        }}
                      </td>
                    </tr>

                    <tr v-if="currentTicket.huongXuLy">
                      <td>Hướng xử lý</td>
                      <td>
                        <span class="badge badge-pill badge-outline-dark">
                          {{ formatHuongXuLy(currentTicket.huongXuLy) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

<!-- COST / STATUS SUMMARY + ẢNH -->
<div class="card mb-2">
  <div class="card-header py-2">
    <h6 class="mb-0" style="font-size: 14px">
      <i class="fa fa-money mr-2"></i>Chi phí &amp; Trạng thái
    </h6>
  </div>
  <div class="card-body p-2 small">
    <!-- TRẠNG THÁI + GARA + CHI PHÍ DUYỆT -->
    <div class="mb-2 border-bottom pb-2">
      <div class="d-flex justify-content-between mb-1">
        <span class="text-muted">Trạng thái phiếu:</span>
        <span
          class="badge"
          :class="getStatusBadge(currentTicket.trangThai)"
        >
          {{ formatTrangThai(currentTicket.trangThai) }}
        </span>
      </div>

      <div class="d-flex justify-content-between mt-1">
        <span class="text-muted">Phương án xử lý:</span>
        <span class="font-weight-bold">
          {{
            currentTicket.huongXuLy
              ? formatHuongXuLy(currentTicket.huongXuLy)
              : "Chưa chọn"
          }}
        </span>
      </div>

      <div class="d-flex justify-content-between mt-1">
        <span class="text-muted">Gara / Nơi làm:</span>
        <span class="font-weight-bold text-truncate" style="max-width: 55%">
          {{ currentTicket.garaDeXuat || "Chưa có" }}
        </span>
      </div>

      <div class="d-flex justify-content-between mt-1">
        <span class="text-muted">Giá đã duyệt:</span>
        <span class="text-success font-weight-bold">
          {{ formatCurrency(currentTicket.giaDuocDuyet) }}
        </span>
      </div>

      <!-- ẢNH BỔ SUNG (CHỈ HIỂN THỊ) -->
      <div class="mt-2">
        <span class="text-muted d-block mb-1">
          Ảnh chụp bổ sung (gara / phụ tùng / hiện trường):
        </span>

        <div
          v-if="ticketImages.baoGia.length > 0"
          class="d-flex flex-wrap"
        >
          <img
            v-for="(img, idx) in ticketImages.baoGia"
            :key="'bg-' + idx"
            :src="img"
            class="img-mini-thumb mr-1 mb-1"
            @click="showLightbox(ticketImages.baoGia, idx)"
          />
        </div>

        <div v-else class="text-muted small">
          Chưa có ảnh bổ sung.
        </div>
      </div>


    </div>

    <!-- CHI PHÍ THỰC TẾ + ẢNH BIÊN LAI -->
    <div class="pt-1">
      <div class="d-flex justify-content-between">
        <span class="text-muted">Chi phí thực tế:</span>
        <span
          class="text-danger font-weight-bold"
          style="font-size: 1.1em"
        >
          {{ formatCurrency(currentTicket.chiPhiThucTe) }}
        </span>
      </div>

      <div v-if="ticketImages.bienLai.length > 0" class="mt-2">
        <span class="text-muted d-block mb-1">
          Ảnh biên lai / hoàn thành:
        </span>
        <div class="d-flex flex-wrap">
          <img
            v-for="(img, idx) in ticketImages.bienLai"
            :key="'bl-' + idx"
            :src="img"
            class="img-mini-thumb mr-1 mb-1"
            @click="showLightbox(ticketImages.bienLai, idx)"
          />
        </div>
      </div>
      <div v-else class="mt-2 text-muted small">
        Chưa có ảnh biên lai.
      </div>
    </div>
  </div>
</div>


            <!-- ACTION ZONE -->
            <div class="card">
              <div class="card-header py-2">
                <h6 class="mb-0" style="font-size: 14px">
                  <i class="fa fa-cogs mr-2"></i>Hành động
                </h6>
              </div>
              <div class="card-body p-2 small">
                <div v-if="formError" class="alert alert-danger py-1 mb-2">
                  {{ formError }}
                </div>

<!-- MOI: chọn hướng xử lý, chỉ nhập Gara nếu RA_GARA -->
<div v-if="currentTicket.trangThai === 'MOI'">
  <div class="alert alert-primary py-2 mb-3 small">
    <i class="fa fa-info-circle mr-1"></i>
    Chọn <strong>phương án xử lý</strong>. 
    Nếu chọn <strong>Đưa xe ra Gara</strong> thì nhập thêm tên gara.
    Sau khi sửa xong chỉ cần nhập ODO, chi phí thực tế &amp; chụp biên lai.
  </div>

  <form @submit.prevent="handleSubmitBaoGia">
    <div class="form-group mb-2">
      <label class="mb-1 small font-weight-bold">
        Phương án xử lý <span class="text-danger">*</span>
      </label>
      <select
        v-model="formGia.huongXuLy"
        class="form-control form-control-sm"
        required
      >
        <option value="" disabled>-- Chọn phương án --</option>
        <option value="MUA_PHU_TUNG">Mua phụ tùng / Tự xử lý</option>
        <option value="RA_GARA">Đưa xe ra Gara sửa chữa</option>
        <option value="DAT_LICH_SAU">Chỉ báo cáo, xử lý sau</option>
      </select>
    </div>

    <!-- Ô gara chỉ hiện khi RA_GARA -->
    <div
      class="form-group mb-2"
      v-if="formGia.huongXuLy === 'RA_GARA'"
    >
      <label class="mb-1 small font-weight-bold">
        Gara / Nơi sửa <span class="text-danger">*</span>
      </label>
      <input
        v-model.trim="formGia.garaDeXuat"
        type="text"
        class="form-control form-control-sm"
        placeholder="VD: Gara Hiệp Lợi..."
      />
    </div>

        <!-- Ảnh chụp bổ sung: nằm trong Hành động -->
    <div class="form-group mb-2">
      <label class="mb-1 small font-weight-bold">
        Ảnh chụp bổ sung (gara / phụ tùng / hiện trường)
        <small class="text-muted">
          ({{ (formGia.anhBaoGiaList || []).length }} ảnh, không bắt buộc)
        </small>
      </label>

      <!-- Grid ảnh đã chụp -->
      <div
        class="image-grid mb-2"
        v-if="formGia.anhBaoGiaList && formGia.anhBaoGiaList.length"
      >
        <div
          class="image-item"
          v-for="(url, idx) in formGia.anhBaoGiaList"
          :key="'bg-form-' + idx"
        >
          <img
            :src="url"
            alt="Ảnh bổ sung"
            @click="showLightbox(formGia.anhBaoGiaList, idx)"
          />
          <button
            type="button"
            class="btn-remove-img"
            @click.stop="removeBaoGiaImage(idx)"
            :disabled="isLoadingDetail || uploadingBaoGia"
          >
            &times;
          </button>
        </div>
      </div>

      <!-- Nút chụp ảnh bổ sung -->
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm btn-dashed"
        :disabled="isLoadingDetail || uploadingBaoGia"
        @click="cameraBaoGiaOpen = true"
      >
        <span
          v-if="uploadingBaoGia"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        <i v-else class="fa fa-camera mr-1"></i>
        {{
          formGia.anhBaoGiaList && formGia.anhBaoGiaList.length
            ? 'Chụp thêm ảnh bổ sung'
            : 'Chụp ảnh bổ sung'
        }}
      </button>
    </div>


    <button
      type="submit"
      class="btn btn-primary btn-block btn-sm mt-2"
      :disabled="isLoadingDetail"
    >
      <span
        v-if="isLoadingDetail"
        class="spinner-border spinner-border-sm"
      ></span>
      <i v-else class="fa fa-save mr-1"></i>
      Lưu phương án xử lý
    </button>
  </form>
</div>



                <!-- DA_DUYET -->
                <div v-else-if="currentTicket.trangThai === 'DA_DUYET'">
                  <div class="alert alert-success py-2 mb-2">
                    Đã duyệt chi phí:
                    <strong>{{
                      formatCurrency(currentTicket.giaDuocDuyet)
                    }}</strong>
                  </div>
                  <button
                    class="btn btn-primary btn-block btn-sm"
                    :disabled="isLoadingDetail"
                    @click="handleBatDauSua"
                  >
                    <span
                      v-if="isLoadingDetail"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    <i v-else class="fa fa-play-circle mr-1"></i>
                    Bắt đầu sửa chữa
                  </button>
                </div>

                <!-- DANG_SUA: tài xế chỉ nhập ODO + chi phí + biên lai -->
                <div v-else-if="currentTicket.trangThai === 'DANG_SUA'">
                  <p class="text-muted mb-2">
                    Sau khi sửa xong / thay đồ xong, nhập chi phí thực tế &amp;
                    chụp ảnh biên lai.
                  </p>
                  <form @submit.prevent="handleHoanThanh">
                    <div class="form-group mb-2">
                      <label class="mb-1">ODO lúc hoàn thành (Km)</label>
                      <input
                        v-model.number="formHoanThanh.odoHoanThanh"
                        type="number"
                        class="form-control form-control-sm"
                        min="0"
                      />
                    </div>
                    <div class="form-group mb-2">
                      <label class="mb-1">
                        Chi phí thực tế (VND)
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model.number="formHoanThanh.chiPhiThucTe"
                        type="number"
                        class="form-control form-control-sm"
                        min="1"
                        required
                      />
                    </div>

                    <div class="form-group mb-2">
                      <label class="mb-1">
                        Ảnh Biên lai / Hóa đơn
                        <span class="text-danger">*</span>
                        <small class="text-muted font-weight-normal">
                          ({{ (formHoanThanh.bienLaiList || []).length }} ảnh)
                        </small>
                      </label>

                      <div
                        class="image-grid mb-2"
                        v-if="formHoanThanh.bienLaiList && formHoanThanh.bienLaiList.length"
                      >
                        <div
                          class="image-item"
                          v-for="(url, idx) in formHoanThanh.bienLaiList"
                          :key="'bl-form-' + idx"
                        >
                          <img
                            :src="url"
                            alt="Ảnh biên lai"
                            @click="showLightbox(formHoanThanh.bienLaiList, idx)"
                          />
                          <button
                            type="button"
                            class="btn-remove-img"
                            @click.stop="removeBienLaiImage(idx)"
                            :disabled="isLoadingDetail || uploadingBienLai"
                          >
                            &times;
                          </button>
                        </div>
                      </div>

                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm btn-dashed"
                        :disabled="isLoadingDetail || uploadingBienLai"
                        @click="cameraBienLaiOpen = true"
                      >
                        <span
                          v-if="uploadingBienLai"
                          class="spinner-border spinner-border-sm mr-1"
                        ></span>
                        <i v-else class="fa fa-camera mr-1"></i>
                        {{
                          formHoanThanh.bienLaiList && formHoanThanh.bienLaiList.length
                            ? "Chụp thêm ảnh biên lai"
                            : "Chụp ảnh biên lai"
                        }}
                      </button>

                      <input
                        type="text"
                        :value="(formHoanThanh.bienLaiList && formHoanThanh.bienLaiList.length) ? 'OK' : ''"
                        required
                        style="
                          width: 0;
                          height: 0;
                          padding: 0;
                          border: none;
                          opacity: 0;
                          position: absolute;
                        "
                        tabindex="-1"
                        aria-hidden="true"
                        @focus.prevent
                      />
                    </div>

                    <button
                      type="submit"
                      class="btn btn-info btn-block btn-sm"
                      :disabled="isLoadingDetail"
                    >
                      <span
                        v-if="isLoadingDetail"
                        class="spinner-border spinner-border-sm"
                      ></span>
                      <i v-else class="fa fa-flag-checkered mr-1"></i>
                      Gửi xác nhận hoàn thành
                    </button>
                  </form>
                </div>

                <!-- CHO_THANH_TOAN -->
                <div v-else-if="currentTicket.trangThai === 'CHO_THANH_TOAN'">
                  <div class="alert alert-info mb-0 py-2">
                    Đã gửi chi phí thực tế:
                    <strong>{{
                      formatCurrency(currentTicket.chiPhiThucTe)
                    }}</strong
                    ><br />
                    Đang chờ kế toán / admin thanh toán.
                  </div>
                </div>

                <!-- HOAN_THANH / DA_HUY -->
                <div
                  v-else-if="
                    currentTicket.trangThai === 'HOAN_THANH' ||
                    currentTicket.trangThai === 'DA_HUY'
                  "
                  class="text-center text-muted"
                >
                  <i
                    v-if="currentTicket.trangThai === 'HOAN_THANH'"
                    class="fa fa-check-circle fa-2x mb-2 text-success"
                  ></i>
                  <i
                    v-else
                    class="fa fa-times-circle fa-2x mb-2 text-secondary"
                  ></i>
                  <p class="mb-0">Phiếu đã được đóng.</p>
                </div>

                <!-- Fallback -->
                <div v-else class="text-muted">
                  Không có hành động nào cho trạng thái này.
                </div>
              </div>
            </div>
          </div>

          <!-- RIGHT: CHAT -->
          <div class="col-lg-7 mb-3">
            <div class="card chat-card">
              <div
                class="card-header py-2 d-flex justify-content-between align-items-center"
              >
                <h6 class="mb-0" style="font-size: 14px">
                  <i class="fa fa-comments mr-2"></i>Trao đổi về phiếu
                </h6>
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click="reloadChat"
                  :disabled="isLoadingChat"
                >
                  <i
                    class="fa fa-sync-alt mr-1"
                    :class="{ 'fa-spin': isLoadingChat }"
                  ></i>
                  Chat mới
                </button>
              </div>
              <div class="card-body chat-body">
                <div v-if="isLoadingChat" class="text-center text-muted py-3">
                  Đang tải tin nhắn...
                </div>
                <div
                  v-else-if="!chatMessages.length"
                  class="text-muted text-center py-3 small"
                >
                  Chưa có tin nhắn nào. Bắt đầu trao đổi với Admin ở đây.
                </div>
                <div v-else class="chat-messages">
                  <div
                    v-for="m in chatMessages"
                    :key="m.id || m.createdAt"
                    class="chat-message"
                    :class="{ 'from-me': m.fromCurrentUser }"
                  >
                    <div class="chat-bubble">
                      <div class="chat-meta">
                        <strong class="mr-1">
                          {{
                            m.senderName || (m.fromCurrentUser ? "Tôi" : "Khác")
                          }}
                        </strong>
                        <small class="text-muted">
                          {{ formatDateTime(m.createdAt) }}
                        </small>
                      </div>
                      <div class="chat-text" v-if="m.message">
                        {{ m.message }}
                      </div>
                      <div v-if="m.attachmentUrl" class="mt-1">
                        <button
                          class="btn btn-xs btn-outline-dark"
                          @click="viewFile(m.attachmentUrl)"
                        >
                          <i class="fa fa-image mr-1"></i> Xem ảnh
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer chat-footer">
                <form @submit.prevent="handleSendMessage">
                  <div class="form-group mb-1">
                    <textarea
                      v-model.trim="chatForm.text"
                      class="form-control form-control-sm"
                      rows="2"
                      placeholder="Nhập nội dung trao đổi..."
                    ></textarea>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="mr-2">             
                    </div>
                    <small
                      v-if="chatForm.attachmentUrl"
                      class="text-truncate mr-2 small"
                      style="max-width: 150px"
                    >
                      Đã chọn ảnh đính kèm
                    </small>
                    <button 
                      type="submit"
                      class="btn btn-primary btn-sm ml-auto"
                      :disabled="
                        isSendingChat ||
                        (!chatForm.text && !chatForm.attachmentUrl)
                      "
                    >
                      <span
                        v-if="isSendingChat"
                        class="spinner-border spinner-border-sm"
                      ></span>
                      <i v-else class="fa fa-paper-plane mr-1"></i> Gửi
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- LIGHTBOX -->
      <VueEasyLightbox
        :visible="lightbox.visible"
        :imgs="lightbox.imgs"
        :index="lightbox.index"
        @hide="handleHideLightbox"
      />

            <FullscreenCamera
        v-model="cameraBaoGiaOpen"
        title="Chụp ảnh bổ sung"
        :busy="isLoadingDetail || uploadingBaoGia"
        initial-facing="environment"
        @confirm="onCameraBaoGiaConfirm"
        @cancel="onCameraBaoGiaCancel"
      />
      <!-- Camera kiểu SOS cho BIÊN LAI -->
      <FullscreenCamera
        v-model="cameraBienLaiOpen"
        title="Chụp ảnh Biên lai / Hóa đơn"
        :busy="isLoadingDetail || uploadingBienLai"
        initial-facing="environment"
        @confirm="onCameraBienLaiConfirm"
        @cancel="onCameraBienLaiCancel"
      />
    </div>
  
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useDriverBaoDuongStore } from "@/stores/driverBaoDuongStore";
import { BaoDuongXeApi } from "@/services/baoDuongXeService";
import VueEasyLightbox from "vue-easy-lightbox";
import FullscreenCamera from "@/components/FullscreenCamera.vue";
import fileService from "@/services/fileService";
import { useNotificationStore } from "@/stores/notificationStore"; // 👈 THÊM

// Helpers
function pad2(n) {
  return String(n).padStart(2, "0");
}
function parseIsoLocal(s) {
  if (!s) return null;
  if (s instanceof Date) return s;
  const m = String(s).match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/
  );
  if (!m) return null;
  const [, y, M, d, h, mi, se] = m;
  return new Date(+y, +M - 1, +d, +h, +mi, +se);
}
function formatDateTime(s) {
  const d = parseIsoLocal(s);
  if (!d) return "-";
  const dd = pad2(d.getDate());
  const MM = pad2(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  const hh = pad2(d.getHours());
  const mm = pad2(d.getMinutes());
  return `${dd}/${MM}/${yyyy} ${hh}:${mm}`;
}
function formatCurrency(value) {
  if (value == null || isNaN(Number(value))) return "-";
  return Number(value).toLocaleString("vi-VN") + " đ";
}

// chỉ còn Gara
const DEFAULT_FORM_GIA = {
  huongXuLy: "", 
  garaDeXuat: "",
  anhBaoGiaUrl: "",   // giữ 1 ảnh cuối (compat BE)
  anhBaoGiaList: [],  // list ảnh bổ sung
};

const DEFAULT_FORM_HOANTHANH = {
  odoHoanThanh: null,
  chiPhiThucTe: null,
  bienLaiUrl: "",
  bienLaiList: [],
};



const DEFAULT_CHAT_FORM = {
  text: "",
  attachmentUrl: "",
};

export default {
  name: "TaiXeBaoDuongPage",
  components: {
    VueEasyLightbox,
    FullscreenCamera,
  },
  data() {
    return {
      activeTab: "LIST",
      filterTrangThai: "ACTIVE",


      formGia: { ...DEFAULT_FORM_GIA },
      formHoanThanh: { ...DEFAULT_FORM_HOANTHANH },
      formError: null,

      chatMessages: [],
      isLoadingChat: false,
      isSendingChat: false,
      chatForm: { ...DEFAULT_CHAT_FORM },

      lightbox: {
        visible: false,
        imgs: [],
        index: 0,
      },

      cameraBaoGiaOpen: false,
      uploadingBaoGia: false,
      // Camera kiểu SOS cho BIÊN LAI
      cameraBienLaiOpen: false,
      uploadingBienLai: false,

      localUserName: (localStorage.getItem("userhoten") || "").trim(),
      localUserRole: (localStorage.getItem("userrole") || "").trim(),
          notiUnsubscribe: null, // 👈 thêm

    };
  },
  computed: {
    ...mapState(useDriverBaoDuongStore, [
      "isLoading",
      "error",
      "tickets",
      "isLoadingDetail",
      "detailError",
      "currentTicket",
    ]),

    filteredTickets() {
      let list = this.tickets || [];

      if (this.filterTrangThai === "DONE") {
        list = list.filter(
          (t) => t.trangThai === "HOAN_THANH" || t.trangThai === "DA_HUY"
        );
      } else {
        list = list.filter(
          (t) => t.trangThai !== "HOAN_THANH" && t.trangThai !== "DA_HUY"
        );
      }

      const statusPriority = {
        DANG_SUA: 1,
        CHO_THANH_TOAN: 2,
        DA_DUYET: 3,
        CHO_DUYET: 4,
        MOI: 5,
        HOAN_THANH: 6,
        DA_HUY: 7,
      };
      const loaiPriority = {
        SU_CO_DOT_XUAT: 1,
        TU_CHECKLIST: 2,
        DINH_KY: 3,
      };

      return list.slice().sort((a, b) => {
        const sa = statusPriority[a.trangThai] ?? 99;
        const sb = statusPriority[b.trangThai] ?? 99;
        if (sa !== sb) return sa - sb;

        const la = loaiPriority[a.loaiBaoDuong] ?? 99;
        const lb = loaiPriority[b.loaiBaoDuong] ?? 99;
        if (la !== lb) return la - lb;

        const da = a.ngayTao ? new Date(a.ngayTao).getTime() : 0;
        const db = b.ngayTao ? new Date(b.ngayTao).getTime() : 0;
        return db - da;
      });
    },

    distinctXeBienSo() {
      const set = new Set();
      (this.tickets || []).forEach((t) => {
        if (t.xeBienSo) set.add(t.xeBienSo);
      });
      return Array.from(set);
    },

        ticketImages() {
      const t = this.currentTicket;
      if (!t) return { suCo: [], baoGia: [], bienLai: [] };

      const getList = (listProp, strProp) => {
        let res = [];
        if (Array.isArray(listProp) && listProp.length) {
          res = [...listProp];
        }
        if (!res.length && strProp) res.push(strProp);
        return res;
      };

      const suCoBase = getList(t.anhSuCoList, t.anhSuCoUrl);
      const baoGiaBase = getList(t.anhBaoGiaList, t.anhBaoGiaUrl);
      const bienLaiBase = getList(t.anhBienLaiList, t.bienLaiUrl);

      const baoGiaFromForm =
        this.formGia &&
        Array.isArray(this.formGia.anhBaoGiaList) &&
        this.formGia.anhBaoGiaList.length
          ? [...this.formGia.anhBaoGiaList]
          : null;

      const bienLaiFromForm =
        this.formHoanThanh &&
        Array.isArray(this.formHoanThanh.bienLaiList) &&
        this.formHoanThanh.bienLaiList.length
          ? [...this.formHoanThanh.bienLaiList]
          : null;

      return {
        suCo: suCoBase,
        baoGia: baoGiaFromForm || baoGiaBase,
        bienLai: bienLaiFromForm || bienLaiBase,
      };
    },
  },
  methods: {
    ...mapActions(useDriverBaoDuongStore, [
      "fetchTickets",
      "openTicketDetail",
      "driverSubmitGia",
      "driverStartSuaChua",
      "driverCompleteSuaChua",
      "createTicketFromSos",
    ]),

      handleRealtimeNotification(n) {
    if (!n) return;

    // bảo hiểm: nếu chưa mở phiếu chi tiết thì khỏi làm gì
    if (!this.currentTicket) return;

    // Cần BE trả đúng các field này trong entity ThongBao
    const loaiThongBao = n.loaiThongBao || n.type || "";
    const loaiDoiTuong = n.loaiDoiTuong || "";
    const idDoiTuong = n.idDoiTuong;

    // Chỉ care thông báo chat bảo dưỡng & đúng phiếu đang mở
    if (
      loaiThongBao === "BAO_DUONG_XE_CHAT" &&
      loaiDoiTuong === "bao-duong-xe" &&
      idDoiTuong === this.currentTicket.id
    ) {
      // có thể tinh vi hơn: nếu đang ở tab khác thì không cần reload
      // nhưng thôi, cho nó chắc
      this.reloadChat();
    }
  },

    // Lightbox
    showLightbox(imgs, index = 0) {
      if (!imgs || !imgs.length) return;
      this.lightbox.imgs = imgs;
      this.lightbox.index = index;
      this.lightbox.visible = true;
    },
    handleHideLightbox() {
      this.lightbox.visible = false;
    },

    // Helpers view
    formatDateTime,
    formatCurrency,
    getStatusBadge(status) {
      switch (status) {
        case "MOI":
          return "badge-light";
        case "CHO_DUYET":
          return "badge-warning";
        case "DA_DUYET":
          return "badge-info";
        case "DANG_SUA":
          return "badge-primary";
        case "CHO_THANH_TOAN":
          return "badge-danger";
        case "HOAN_THANH":
          return "badge-success";
        case "DA_HUY":
          return "badge-secondary";
        default:
          return "badge-light";
      }
    },
    formatTrangThai(status) {
      switch (status) {
        case "MOI":
          return "Mới tạo";
        case "CHO_DUYET":
          return "Chờ duyệt";
        case "DA_DUYET":
          return "Đã duyệt";
        case "DANG_SUA":
          return "Đang sửa";
        case "CHO_THANH_TOAN":
          return "Chờ thanh toán";
        case "HOAN_THANH":
          return "Hoàn thành";
        case "DA_HUY":
          return "Đã hủy";
        default:
          return status;
      }
    },
    getLoaiBadge(loai) {
      switch (loai) {
        case "DINH_KY":
          return "badge-info";
        case "TU_CHECKLIST":
          return "badge-warning";
        case "SU_CO_DOT_XUAT":
          return "badge-danger";
        default:
          return "badge-light";
      }
    },
    formatLoai(loai) {
      switch (loai) {
        case "DINH_KY":
          return "Định kỳ";
        case "TU_CHECKLIST":
          return "Checklist";
        case "SU_CO_DOT_XUAT":
          return "Sự cố";
        default:
          return loai;
      }
    },
    formatHuongXuLy(code) {
      switch (code) {
        case "MUA_PHU_TUNG":
          return "Mua phụ tùng";
        case "RA_GARA":
          return "Ra gara sửa";
        case "DAT_LICH_SAU":
          return "Đặt lịch xử lý sau";
        default:
          return code || "-";
      }
    },
    truncate(text, length) {
      if (!text) return "";
      const s = String(text);
      if (s.length <= length) return s;
      return s.substring(0, length) + "...";
    },

    handleReload() {
      this.fetchTickets();
    },

    async openTicket(ticket) {
      this.activeTab = "DETAIL";
      this.formError = null;
      this.formGia = { ...DEFAULT_FORM_GIA };
      this.formHoanThanh = { ...DEFAULT_FORM_HOANTHANH };

           await this.openTicketDetail(ticket.id);

      if (this.currentTicket) {
        this.formGia.huongXuLy = this.currentTicket.huongXuLy || "";
        this.formGia.garaDeXuat = this.currentTicket.garaDeXuat || "";
        this.formGia.anhBaoGiaUrl = this.currentTicket.anhBaoGiaUrl || "";
        this.formGia.anhBaoGiaList =
          this.currentTicket.anhBaoGiaList?.slice() || [];

        this.formHoanThanh.odoHoanThanh =
          this.currentTicket.odoHoanThanh || null;
        this.formHoanThanh.chiPhiThucTe =
          this.currentTicket.chiPhiThucTe || null;
        this.formHoanThanh.bienLaiUrl = this.currentTicket.bienLaiUrl || "";
        this.formHoanThanh.bienLaiList =
          this.currentTicket.anhBienLaiList?.slice() || [];
      }

      await this.reloadChat();
    },

    goToDetailTab() {
      if (this.currentTicket) {
        this.activeTab = "DETAIL";
      }
    },

    viewFile(url) {
      if (!url) return;
      window.open(url, "_blank", "noopener,noreferrer");
    },

    // CREATE ticket
    // async handleCreateTicket() {
    //   this.createError = null;

    //   if (!this.createForm.xeBienSo || !this.createForm.noiDungCongViec) {
    //     this.createError = "Vui lòng nhập biển số xe & mô tả sự cố.";
    //     return;
    //   }

    //   const payload = {
    //     xeBienSo: this.createForm.xeBienSo,
    //     noiDungCongViec: this.createForm.noiDungCongViec,
    //     boPhan: this.createForm.boPhan || null,
    //     anhSuCoUrl: this.createForm.anhSuCoUrl || null,
    //     odoLucTao: this.createForm.odoLucTao || null,
    //   };

    //   try {
    //     this.isSubmittingCreate = true;
    //     const newTicket = await this.createTicketFromSos(payload);
    //     this.createForm = { ...DEFAULT_CREATE_FORM };
    //     await this.fetchTickets();
    //     await this.openTicket(newTicket);
    //     alert("Đã tạo phiếu bảo dưỡng / sửa chữa.");
    //   } catch (e) {
    //     this.createError =
    //       e?.response?.data?.message ||
    //       e?.message ||
    //       "Lỗi tạo phiếu, vui lòng thử lại.";
    //   } finally {
    //     this.isSubmittingCreate = false;
    //   }
    // },

    // cập nhật Gara / nơi sửa (thay cho gửi báo giá)
async handleSubmitBaoGia() {
  if (!this.currentTicket) return;
  this.formError = null;

  // bắt buộc chọn hướng xử lý
  if (!this.formGia.huongXuLy) {
    this.formError = "Vui lòng chọn Phương án xử lý.";
    return;
  }

// Chỉ khi chọn RA_GARA mới bắt buộc nhập gara
if (
  this.formGia.huongXuLy === "RA_GARA" &&
  (!this.formGia.garaDeXuat || !this.formGia.garaDeXuat.trim())
) {
  this.formError = "Vui lòng nhập Gara / nơi sửa.";
  return;
}

    try {
    const list = Array.isArray(this.formGia.anhBaoGiaList)
      ? this.formGia.anhBaoGiaList
      : [];

    await this.driverSubmitGia(this.currentTicket.id, {
      huongXuLy: this.formGia.huongXuLy,
      garaDeXuat:
    this.formGia.huongXuLy === "RA_GARA"
      ? (this.formGia.garaDeXuat?.trim() || null)
      : null,             // bonus: tránh lưu rác gara cũ khi đổi phương án

      giaDeXuat: 0,
      thoiGianDuKien: null,
      anhBaoGiaUrl: list.length ? list[list.length - 1] : null,
      anhBaoGiaList: list,
    });


    alert("Đã lưu phương án xử lý & gara.");
    await this.openTicketDetail(this.currentTicket.id);
    await this.fetchTickets();
  } catch (e) {
    this.formError =
      this.detailError || "Lỗi lưu phương án xử lý, vui lòng thử lại.";
  }
},


    // BẮT ĐẦU SỬA
    async handleBatDauSua() {
      if (!this.currentTicket) return;
      this.formError = null;
      if (!confirm("Xác nhận bắt đầu sửa chữa?")) return;
      try {
        await this.driverStartSuaChua(this.currentTicket.id);
        alert("Đã cập nhật trạng thái Đang sửa.");
        await this.openTicketDetail(this.currentTicket.id);
        await this.fetchTickets();
      } catch (e) {
        this.formError =
          this.detailError || "Lỗi cập nhật trạng thái Đang sửa.";
      }
    },

    // HOÀN THÀNH
    async handleHoanThanh() {
      if (!this.currentTicket) return;
      this.formError = null;

      const hasBienLaiList =
        Array.isArray(this.formHoanThanh.bienLaiList) &&
        this.formHoanThanh.bienLaiList.length > 0;

      if (
        !this.formHoanThanh.chiPhiThucTe ||
        this.formHoanThanh.chiPhiThucTe <= 0 ||
        (!hasBienLaiList && !this.formHoanThanh.bienLaiUrl)
      ) {
        this.formError =
          "Vui lòng nhập Chi phí thực tế (>0) và chụp ít nhất 1 ảnh biên lai.";
        return;
      }

      if (!confirm("Xác nhận đã sửa xong & gửi chi phí thực tế?")) return;

      try {
        const payload = {
          odoHoanThanh: this.formHoanThanh.odoHoanThanh,
          chiPhiThucTe: this.formHoanThanh.chiPhiThucTe,
          bienLaiUrl: this.formHoanThanh.bienLaiUrl || null,
          bienLaiList: this.formHoanThanh.bienLaiList || [],
        };

        await this.driverCompleteSuaChua(this.currentTicket.id, payload);
        alert("Đã gửi xác nhận hoàn thành, chờ thanh toán.");
        await this.openTicketDetail(this.currentTicket.id);
        await this.fetchTickets();
      } catch (e) {
        this.formError =
          this.detailError || "Lỗi xác nhận hoàn thành, vui lòng thử lại.";
      }
    },

    // CHAT
    async reloadChat() {
      if (!this.currentTicket) return;
      this.isLoadingChat = true;

      try {
        const data = await BaoDuongXeApi.getChat(this.currentTicket.id);
        const normLocalName = this.localUserName.toUpperCase();

        this.chatMessages = (data || []).map((m) => {
          const senderName = (m.authorName || "").trim();
          const senderRole = m.authorRole || "";
          const msgText = m.text || "";

          const isMineByName =
            normLocalName &&
            senderName &&
            normLocalName === senderName.toUpperCase();

          const isMineByRole = senderRole === "TAI_XE";

          const fromMe = isMineByName || isMineByRole;

          return {
            id: m.id,
            message: msgText,
            attachmentUrl: m.attachmentUrl || null,
            createdAt: m.createdAt || m.created_at,
            senderName: senderName || (fromMe ? "Tôi" : "Không rõ"),
            fromCurrentUser: fromMe,
          };
        });
      } catch (e) {
        console.error("load chat error", e);
      } finally {
        this.isLoadingChat = false;
      }
    },

    async handleSendMessage() {
      if (!this.currentTicket) return;
      if (!this.chatForm.text && !this.chatForm.attachmentUrl) return;

      this.isSendingChat = true;
      try {
        const payload = {
          text: this.chatForm.text || null,
          attachmentUrl: this.chatForm.attachmentUrl || null,
        };

        const saved = await BaoDuongXeApi.sendChat(
          this.currentTicket.id,
          payload
        );

        this.chatMessages.push({
          id: saved?.id || Date.now(),
          message: saved?.message || this.chatForm.text,
          attachmentUrl:
            saved?.attachmentUrl || this.chatForm.attachmentUrl,
          createdAt: saved?.createdAt || new Date().toISOString(),
          senderName: saved?.senderName || "Tôi",
          fromCurrentUser: true,
        });

        this.chatForm = { ...DEFAULT_CHAT_FORM };
      } catch (e) {
        alert(
          e?.response?.data?.message || e?.message || "Gửi chat thất bại."
        );
      } finally {
        this.isSendingChat = false;
      }
    },

    // CAMERA ẢNH BỔ SUNG (gara / phụ tùng / hiện trường)
    async onCameraBaoGiaConfirm({ blob }) {
      if (!blob || this.uploadingBaoGia) return;
      this.uploadingBaoGia = true;
      try {
        const rawFile = new File([blob], `bao_gia_${Date.now()}.jpg`, {
          type: "image/jpeg",
        });

        const formData = new FormData();
        formData.append("files", rawFile, rawFile.name);
        formData.append("folderName", "bao_duong_bao_gia");

        const res = await fileService.upload(formData);
        const first = Array.isArray(res.data) ? res.data[0] : null;

        if (first?.location) {
          if (!Array.isArray(this.formGia.anhBaoGiaList)) {
            this.formGia.anhBaoGiaList = [];
          }
          this.formGia.anhBaoGiaList.push(first.location);
          this.formGia.anhBaoGiaUrl = first.location;
        } else {
          throw new Error("Server không trả về URL file.");
        }
      } catch (e) {
        console.error("Upload ảnh bổ sung lỗi:", e);
        this.formError =
          e?.response?.data?.error ||
          e?.message ||
          "Không upload được ảnh bổ sung, thử lại.";
      } finally {
        this.uploadingBaoGia = false;
        this.cameraBaoGiaOpen = false;
      }
    },
    onCameraBaoGiaCancel() {
      this.cameraBaoGiaOpen = false;
    },
    removeBaoGiaImage(index) {
      if (!Array.isArray(this.formGia.anhBaoGiaList)) return;
      this.formGia.anhBaoGiaList.splice(index, 1);
      this.formGia.anhBaoGiaUrl =
        this.formGia.anhBaoGiaList[this.formGia.anhBaoGiaList.length - 1] ||
        "";
    },  

    // CAMERA BIÊN LAI (kiểu SOS)
    async onCameraBienLaiConfirm({ blob }) {
      if (!blob || this.uploadingBienLai) return;
      this.uploadingBienLai = true;
      try {
        const rawFile = new File([blob], `bien_lai_${Date.now()}.jpg`, {
          type: "image/jpeg",
        });

        const formData = new FormData();
        formData.append("files", rawFile, rawFile.name);
        formData.append("folderName", "bao_duong_bien_lai");

        const res = await fileService.upload(formData);
        const first = Array.isArray(res.data) ? res.data[0] : null;

        if (first?.location) {
          if (!Array.isArray(this.formHoanThanh.bienLaiList)) {
            this.formHoanThanh.bienLaiList = [];
          }
          this.formHoanThanh.bienLaiList.push(first.location);
          this.formHoanThanh.bienLaiUrl = first.location;
        } else {
          throw new Error("Server không trả về URL file.");
        }
      } catch (e) {
        console.error("Upload ảnh biên lai lỗi:", e);
        this.formError =
          e?.response?.data?.error ||
          e?.message ||
          "Không upload được ảnh biên lai, thử lại.";
      } finally {
        this.uploadingBienLai = false;
        this.cameraBienLaiOpen = false;
      }
    },
    onCameraBienLaiCancel() {
      this.cameraBienLaiOpen = false;
    },
    removeBienLaiImage(index) {
      if (!Array.isArray(this.formHoanThanh.bienLaiList)) return;
      this.formHoanThanh.bienLaiList.splice(index, 1);
      this.formHoanThanh.bienLaiUrl =
        this.formHoanThanh.bienLaiList[
          this.formHoanThanh.bienLaiList.length - 1
        ] || "";
    },
  },

  async mounted() {
    await this.fetchTickets();

    // Đăng ký nghe realtime notification
  const notificationStore = useNotificationStore();

  this.notiUnsubscribe = notificationStore.$onAction(
    ({ name, args, after }) => {
      if (name === "addNotification") {
        after(() => {
          const n = args[0]; // đối số đầu vào addNotification(n)
          this.handleRealtimeNotification(n);
        });
      }
    }
  );
  },
  beforeDestroy() {
  if (this.notiUnsubscribe) {
    this.notiUnsubscribe();
    this.notiUnsubscribe = null;
  }
},
};
</script>



<style scoped>
.driver-bd-content {
  padding: 8px 10px;
}

/* Stack mobile */
.bd-section {
  width: 100%;
}

/* Chat không phá chiều cao */
.chat-card {
  max-height: 65vh;
}

/* Ticket card gọn hơn */
.ticket-card {
  border-radius: 10px;
}


/* Sub tabs */
.driver-subtabs .nav-link {
  padding: 0.4rem 0.2rem;
  font-size: 13px;
  border-radius: 999px;
}
.driver-subtabs .nav-link.active {
  font-weight: 600;
}

/* Tabs scrollable filter trạng thái */
.nav-tabs-scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.nav-tabs-scrollable::-webkit-scrollbar {
  display: none;
}
.nav-tabs-bottom .nav-link {
  font-weight: 500;
  color: #495057;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 0.45rem 0.75rem;
  font-size: 13px;
}
.nav-tabs-bottom .nav-link.active {
  font-weight: 600;
  color: #0d6efd;
  border-bottom-color: #0d6efd;
}

/* Ticket cards */
.ticket-card {
  border-radius: 0.6rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}
.ticket-card:hover {
  background-color: #f8f9fa;
}
.ticket-title-row {
  display: flex;
}
.ticket-title {
  font-size: 14px;
  line-height: 1.35;
}
.xe-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #f1f3f5;
}
.min-action-width {
  min-width: 72px;
}

/* Badge tweak */
.badge {
  padding: 0.3em 0.55em;
  font-size: 0.72rem;
  font-weight: 500;
}
.badge-light {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
}
.badge-source {
  border-radius: 999px;
}
.badge-outline-dark {
  border: 1px solid #495057;
  background-color: #fff;
  color: #495057;
}

/* Detail section */
.ticket-info-table td:first-child {
  width: 110px;
  background-color: #f8f9fa;
  font-weight: 500;
  font-size: 13px;
}
.ticket-info-table td {
  vertical-align: middle;
  font-size: 13px;
}

/* Grid ảnh sự cố */
.img-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  gap: 8px;
  margin-top: 4px;
}
.img-thumb-item {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  cursor: pointer;
  position: relative;
}
.img-thumb-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s;
}
.img-thumb-item:active img {
  transform: scale(0.95);
}

/* Ảnh mini (Báo giá, Biên lai) */
.img-mini-thumb {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #dee2e6;
  cursor: pointer;
}

/* Chat styles */
.chat-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.chat-body {
  flex: 1;
  padding: 6px;
  max-height: 430px;
  overflow-y: auto;
}
.chat-messages {
  display: flex;
  flex-direction: column;
}
.chat-message {
  display: flex;
  margin-bottom: 6px;
}
.chat-message.from-me {
  justify-content: flex-end;
}
.chat-bubble {
  max-width: 80%;
  padding: 6px 8px;
  border-radius: 8px;
  background-color: #f1f3f5;
  font-size: 13px;
}
.chat-message.from-me .chat-bubble {
  background-color: #0d6efd;
  color: #ffffff;
}
.chat-message.from-me .chat-meta small {
  color: #e9ecef !important;
}
.chat-meta {
  font-size: 11px;
  margin-bottom: 2px;
}
.chat-text {
  white-space: pre-wrap;
  word-break: break-word;
}
.chat-footer {
  padding: 6px 8px;
}
.btn-xs {
  padding: 2px 7px;
  font-size: 11px;
}

/* Responsive */
@media (max-width: 767.98px) {
  .driver-bd-wrapper .content.container-fluid {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .page-header {
    margin-bottom: 0.4rem;
  }
  .page-title {
    font-size: 17px;
  }
  .chat-body {
    max-height: 340px;
  }
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.image-item {
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.btn-remove-img {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 0, 0, 0.85);
  color: #fff;
  border: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  border-bottom-left-radius: 6px;
}

.btn-dashed {
  border-style: dashed;
  border-width: 2px;
}

</style>
